import type { AdminAnnouncementEmailTemplateDefinition } from "./types";
import {
    formatListBlock,
    joinBlocks,
    splitLines,
} from "./utils";

export const serviceUpdateTemplate: AdminAnnouncementEmailTemplateDefinition = {
    key: "SERVICE_UPDATE",
    label: "Service Update",
    description:
        "Designed for maintenance windows, platform changes, or temporary service impact.",
    recommendedAnnouncementType: "SYSTEM_MAINTENANCE",
    messageLabel: "Update Details *",
    messagePlaceholder:
        "Describe what is changing, why it matters, and what users should expect.",
    previewEyebrow: "Service Update",
    previewHeaderClassName:
        "bg-[linear-gradient(135deg,#1d4ed8_0%,#2563eb_48%,#0f172a_100%)]",
    previewBadgeClassName:
        "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
    fields: [
        {
            id: "timeWindow",
            label: "Time Window",
            type: "text",
            placeholder: "Tonight, 11:00 PM - 1:00 AM",
            required: true,
        },
        {
            id: "affectedServices",
            label: "Affected Services",
            type: "textarea",
            placeholder: "One affected flow per line",
            rows: 4,
        },
        {
            id: "nextSteps",
            label: "Recommended User Action",
            type: "textarea",
            placeholder: "One action per line",
            rows: 4,
        },
    ],
    buildBody: ({ message, fields }) =>
        joinBlocks([
            fields.timeWindow?.trim()
                ? `We’re sharing a service update for ${fields.timeWindow.trim()}.`
                : "We’re sharing a service update.",
            message,
            fields.affectedServices
                ? formatListBlock("Affected services", fields.affectedServices)
                : null,
            fields.nextSteps
                ? formatListBlock("What to do next", fields.nextSteps)
                : null,
        ]),
    buildPreviewSections: ({ message, fields }) => [
        ...(fields.timeWindow?.trim()
            ? [
                  {
                      label: "Maintenance Window",
                      body: fields.timeWindow.trim(),
                      tone: "accent" as const,
                  },
              ]
            : []),
        {
            label: "What’s Changing",
            body: message,
            tone: "default",
        },
        ...(splitLines(fields.affectedServices || "").length > 0
            ? [
                  {
                      label: "Affected Services",
                      body: splitLines(fields.affectedServices || "").join("\n"),
                      tone: "muted" as const,
                      list: true,
                  },
              ]
            : []),
        ...(splitLines(fields.nextSteps || "").length > 0
            ? [
                  {
                      label: "Next Steps",
                      body: splitLines(fields.nextSteps || "").join("\n"),
                      tone: "accent" as const,
                      list: true,
                  },
              ]
            : []),
    ],
};
